export const getDecimalSeparator = (locale?: string) => {
  const numberWithDecimal = 1.1;
  const formatted = numberWithDecimal.toLocaleString(locale);
  return formatted.replace(/\d/g, '')[0];
};
